export function getTapTickerFromSlug(slug?: string | null): string | null {
	if (!slug) return null
	let value = slug
	try {
		value = decodeURIComponent(slug)
	} catch {
		// Keep the original slug if it is not URI encoded.
	}
	if (!value.toLowerCase().startsWith('tap-')) return null
	const ticker = value.slice('tap-'.length).trim().toLowerCase()
	return ticker || null
}
